React = require('react')

ExampleIntro = require('./examples/intro')
FormExample = require('./examples/form-interaction')

module.exports = React.createClass
    render: ->
        return (
            React.createElement("div", null,
                React.createElement(ExampleIntro, null)
            )
        )



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/components/pages/examples.cjsx
 **/